import React from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const AudioTourHeroSection = ({ fields }) => {
    if (!fields) return null;

    const heading = sanitize(fields.heading);
    const description = sanitize(fields.description);
    const stats = Array.isArray(fields.stats) ? fields.stats : [];
    
    // Get background image URL from API response
    const getBackgroundImageUrl = (bgImage) => {
        if (!bgImage) return null;
        // Priority: url > 2048x2048 > large > 1536x1536 > medium_large
        return bgImage.url 
            || bgImage.sizes?.['2048x2048'] 
            || bgImage.sizes?.large 
            || bgImage.sizes?.['1536x1536'] 
            || bgImage.sizes?.medium_large
            || null;
    };
    
    const backgroundImage = getBackgroundImageUrl(fields.background_image);
    const backgroundImageMobile = getBackgroundImageUrl(fields.background_image_mobile);

    // Get icon URL from API response
    const getIconUrl = (icon) => {
        if (!icon) return null;
        return icon.url || icon.sizes?.['2048x2048'] || icon.sizes?.large || icon.sizes?.['1536x1536'] || null;
    };

    if (!heading && !description && !stats.length) return null;

    return (
        <section className="audio_tour_hero">
            {/* Hero Image + Overlay */}
            <div className="audio_tour_hero_image">
                {backgroundImage && (
                    <picture>
                        {backgroundImageMobile && (
                            <source media="(max-width: 768px)" srcSet={backgroundImageMobile} />
                        )}
                        <img
                            src={backgroundImage}
                            alt={
                                fields?.background_image_mobile?.alt ||
                                fields?.background_image?.alt ||
                                `${heading || "Audio Tour"} - Hero Background`
                            }
                            className="audio_tour_hero_bg_img"
                            fetchPriority="high"
                            loading="eager"
                        />
                    </picture>
                )}
                <div className="audio_tour_overlay">
                    <div className="container">
                        <div className="overlay-content">
                            {heading && <h1>{heading}</h1>}
                            {description && <p>{description}</p>}
                        </div>
                    </div>
                </div>
            </div>

                {/* Stats Box */}
                {stats.length > 0 && (
                    <div className="stats-box audio-tour-stats">
                        {stats.map((stat, index) => {
                            const iconUrl = getIconUrl(stat.icon);
                            const text = sanitize(stat.text);
                            
                            if (!iconUrl && !text) return null;

                            return (
                                <React.Fragment key={index}>
                                    {index > 0 && <div className="divider"></div>}
                                    <div className="stat-item">
                                        {iconUrl && (
                                            <div className="info-item-img">
                                                <img src={iconUrl} alt={stat.icon?.alt || "Icon"} />
                                            </div>
                                        )}
                                        {text && <p>{text}</p>}
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
        </section>
    );
};

export default AudioTourHeroSection;

